import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useUsers } from '../metodos/userContext';
import CompletarPerfilNuevoTutor from './tutorRoute/Usuario/CompletarPerfil';
import PermisoInsuficiente from './Logins/noPermisos';
import HomeScreenTutor from './tutorRoute/HomeScreenTutor';
import HomeScreenAdmin from './adminRoute/HomeScreenAdmin';
import PresentarPrueba from './tutorRoute/Usuario/PresentarPrueba';
import HomeScreenCliente from './clienteRoute/HomeScreenCliente';
import ErrorWidget from '../components/Loadings/ErrorWidget';
import LoadingWidget from '../components/Loadings/LoadingWidget';

const HomeScreenPrincipal = () => {
  const { usuario ,loadingUsuario, errorUsuario} = useUsers();
  const location = useLocation();
  const [activeRoute, setActiveRoute] = useState('/solicitudes/disponibles');
  const navigate = useNavigate();

  // Actualizar la ruta activa cada vez que cambia la ubicación
  useEffect(() => {
      const path = location.pathname;
      
      // Manejar la ruta raíz
      if (path === '/') {
        setActiveRoute('/dashboard');
        navigate('/dashboard', { replace: true });
        return;
      }
      

  }, [location, navigate]);

  //cargando usuario
  if (loadingUsuario) {
    return (
      <LoadingWidget
        mensaje={"Cargando datos del usuario..."}
      />
    );
  }

  //usuario no cargado
  if(usuario === null){
    return(
      <ErrorWidget
        titulo="Error al obtener usuario"
        mensaje={errorUsuario}
      />
    );
  }

  //VERIFICAR ROL DEL USUARIO
  if(usuario.rol == "PROSPECTO"){
    //prospecto aprobado
    if(usuario.prospectoAprobado ){
        return (
          <PresentarPrueba/>
        );
    } 
    //prospecto no aprobado
    else{
      return (
          <CompletarPerfilNuevoTutor/>
        );
    }
   
  }

  //CLIENTES
  if(usuario.rol == "CLIENTE"){
    return (
      <div>
        <HomeScreenCliente/>
      </div>
    )
  }

  //TUTOR
  if(usuario.rol =="TUTOR"){
     return (
        <div>
            <HomeScreenTutor/>
        </div>
    )
  }

  //verificar si tutor no esta expulsado, tambien sanciones, etc
  if(usuario.expulsado){
    return <PermisoInsuficiente />;
  }

  //ADMIN Y COLABORADOR
  if(usuario.rol == "ADMIN" || usuario.rol == "COLABORADOR"){
    return (
        <div>
            <HomeScreenAdmin/>
        </div>
    )
   }

  else {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <p className="text-lg font-medium text-red-600">Rol de usuario no reconocido</p>
          <p className="mt-2 text-gray-600">Contacta al administrador rol = {usuario.rol}</p>
        </div>
      </div>
    );
  }

}

export default HomeScreenPrincipal
